import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../authentication';
import { AuthGuard } from '@app/core/guards/auth.guard';
import { Permission } from '@app/core/authentication/permission';
import { CaseModuleRoutes } from '@app/modules/case/case-routes';

@Injectable({ providedIn: 'root' })
export class CaseAuthGuard extends AuthGuard implements CanActivate {
    constructor(
        protected router: Router,
        protected authenticationService: AuthenticationService
    ) {
        super(router, authenticationService);
    }

    protected permissionsCheck(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const canEditCase = this.authenticationService.currentUserValue.hasPermissions(Permission.SMP_CASE_EDIT);

        if (canEditCase && route.routeConfig.path === `${CaseModuleRoutes.QUICK_PROCESSING}`) {
            const canQuickProcess = this.authenticationService.currentUserValue.hasPermissions(Permission.SMP_CASE_SWITCH_VIEW);

            if (!canQuickProcess) {
                if (route && route.params && route.params.id) {
                    const detailedProcessing = CaseModuleRoutes.DETAILED_PROCESSING.replace(':id', route.params.id);
                    return this.router.navigateByUrl(`${detailedProcessing}/${CaseModuleRoutes.GENERAL}`)
                                      .then(() => {
                                          return canQuickProcess;
                                      });
                } else {
                    return super.unauthorisedAction();
                }
            } else {
                return Promise.resolve(canQuickProcess);
            }
        } else {
            return Promise.resolve(canEditCase);
        }
    }
}
